module.exports = __webpack_public_path__ + "h5/img/404.aa996bb5.png";